var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ tableLoading: _vm.tableLoading },attrs:{"id":"tableDiv"}},[_c('div',{attrs:{"id":"stateCountyTable"}},[(_vm.displayOutput === 'cases')?_c('v-data-table',{attrs:{"disable-page-reset":"","headers":[
          {text: 'Vaccination Goal',
          align: 'start',
          sortable: true,
          value: 'goal'
          },
          {text: _vm.displayOutput, value: 'cases', align: 'center'
          },
          {text: 'Averted', value: 'casesAverted', align: 'center'} ],"items":_vm.items,"dark":"","footer-props":{
        prevIcon: '〈',
        nextIcon: '〉'
      }},scopedSlots:_vm._u([{key:"item.goal",fn:function(ref){
      var item = ref.item;
return [(item.goal === 'No Vaccination' || item.goal === 'Base Vaccination')?_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(item.goal))]):_vm._e(),(item.goal !== 'No Vaccination' && item.goal !== 'Base Vaccination')?_c('div',[_vm._v(_vm._s(item.goal))]):_vm._e()]}},{key:"item.cases",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.cases).toLocaleString()))])]}},{key:"item.casesAverted",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.casesAverted).toLocaleString()))])]}}],null,false,2538987328)}):_vm._e(),(_vm.displayOutput === 'deaths')?_c('v-data-table',{attrs:{"disable-page-reset":"","headers":[
          {text: 'Vaccination Goal',
          align: 'start',
          sortable: true,
          value: 'goal'
          },
          {text: _vm.displayOutput, value: 'deaths', align: 'center'
          },
          {text: 'Averted', value: 'deathsAverted', align: 'center'} ],"items":_vm.items,"dark":"","footer-props":{
        prevIcon: '〈',
        nextIcon: '〉'
      }},scopedSlots:_vm._u([{key:"item.goal",fn:function(ref){
      var item = ref.item;
return [(item.goal === 'No Vaccination' || item.goal === 'Base Vaccination')?_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(item.goal))]):_vm._e(),(item.goal !== 'No Vaccination' && item.goal !== 'Base Vaccination')?_c('div',[_vm._v(_vm._s(item.goal))]):_vm._e()]}},{key:"item.deaths",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.deaths).toLocaleString()))])]}},{key:"item.deathsAverted",fn:function(ref){
      var item = ref.item;
return [_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(Number(item.deathsAverted).toLocaleString()))])]}}],null,false,1959421472)}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }